import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { translationHookOptions } from "../../../app/localization/localization";
import { RootStoreContext } from "../../../app/stores/rootStore";

const BrushButton: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { isBrushEnabled, isZoomed, ZwibblerUseBrushTool, ZwibblerEnableReadOnlyMode } =
    rootStore.zwibblerStore;
  const { theme } = rootStore.commonStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  const handleClick = () => {
    if(isBrushEnabled)ZwibblerEnableReadOnlyMode();
    else ZwibblerUseBrushTool();
  };

  return (
    <>
      <Button
        id="brush"
        className={classNames(
          "w-100 px-1 pt-1 pb-1 transparentButton toolbarButton",
          isBrushEnabled
            ? `${theme!.toolbarActiveIconColor}`
            : `${theme!.toolbarIconColor}`
        )}
        disabled={isZoomed}
        color=""
        onClick={() => handleClick()}
        style={{ position: "relative" }}
      >
        <i
          className={classNames(
            "fas fa-marker iconToolbarButton",
            isBrushEnabled ? "" : ""
          )}
        ></i>
        <h6 className="textToolbarButton mb-0">{t("toolbar_brush_button")}</h6>
      </Button>
    </>
  );
};

export default observer(BrushButton);
